const w = window;
const $ = jQuery;
const path = location.pathname;

/****************************
 * 製品案内の場合
 */
if( path.indexOf('/product/') >= 0 ){
$(()=>{

  if( $('[data-tab]').length && $('[data-tabcont]').length ){
    const $tabs = $('[data-tab]')
    const $conts = $('[data-tabcont]')
    const init = ()=>{

      if( $('[data-tab].current').length == 0 && $(w).width() >= 768 ){
        $('[data-tab]:eq(0)').addClass('current');
      }
      
      $('[data-tabcont]').removeClass('d-none').hide();

      if( $('[data-tabcont] a.current').length == 0 && $(w).width() >= 768 ){
        $('[data-tabcont]:eq(0)').show();
      }else{
        $('[data-tabcont] a.current').parents('[data-tabcont]').show();
      }

    }
    const tabChange = (e)=>{
      // if(!e.data.$tab.hasClass('current')){
        $tabs.removeClass('current');
        e.data.$tab.addClass('current');
        $conts.each(function(){
          if( e.data.$cont.data('tabcont') != $(this).data('tabcont')) $(this).slideUp();
        });
        e.data.$cont.slideToggle();
      // }
    }

    $tabs.each(function(){
      const $this = $(this);
      const tabname = $(this).data('tab');
      const $related_cont = $(`[data-tabcont=${tabname}]`);
      $(this).on('click',{$tab:$this,$cont:$related_cont},tabChange);
    })
    init();
  }

})
}